// Utilidad para scroll suave con easing y ajuste de offset
const easeInOutCubic = (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

export const animateScrollTo = (targetY: number, duration = 700) => {
  const startY = window.scrollY || window.pageYOffset;
  const distance = targetY - startY;
  let startTime: number | null = null;

  const step = (timestamp: number) => {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeInOutCubic(progress);
    window.scrollTo(0, startY + distance * eased);
    if (elapsed < duration) {
      window.requestAnimationFrame(step);
    }
  };

  window.requestAnimationFrame(step);
};

export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const headerHeight = 80; // Ajuste por header fijo
    const rect = element.getBoundingClientRect();
    const elementPosition = rect.top + window.pageYOffset - headerHeight;
    animateScrollTo(elementPosition, 700);

    // Resaltar suavemente la sección al llegar (opcional) 
    element.classList.add('ring-2', 'ring-primary', 'ring-offset-1');
    setTimeout(() => {
      element.classList.remove('ring-2', 'ring-primary', 'ring-offset-1');
    }, 1000);
  }
};

export const isHomePage = () => window.location.pathname === '/';